export const lawyerStatusConst = { Approved: 'موافقة', Pending: 'معلق', Blocked: 'حظر' };
